// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-1C8Qb","icon":"icon-2uOLV","title":"title-T2IyW","description":"description-2CEC6","price":"price-J2y0d"};